import { useEffect, useState } from 'react'
import {useCart} from './useCart'
import axios from 'axios'
import getMatchingVariants from '../components/portals/QuickAdd/getMatchingVariants'
import getRoute from '../../scripts/utils/getRoute'

export const useQuickAdd = () => {

  const [handle, setHandle] = useState(null)
  const [product, setProduct] = useState(null)
  const [stockMap, setStockMap] = useState({})
  const [selectedOptions, setSelectedOptions] = useState([null, null, null])
  const [currentVariant, setCurrentVariant] = useState(null)
  const { addToCart } = useCart();

  const setDOMHelpers = () => {
    window['blubolt'].quickadd = {
      open: (handle, settings) => {
        let stockMap = {}
        try {
          stockMap = JSON.parse(settings.stockMap);
        } catch (e) {
          console.info(e)
        }
        setStockMap(stockMap)
        setHandle(handle)
      }
    }
  }

  useEffect(() => {
    setDOMHelpers()
  }, [])

  useEffect(() => {
    if (!product) {
      setCurrentVariant(null)
      return
    }
    const matchingVariants = getMatchingVariants(selectedOptions, product.variants);
    const selectedLength = selectedOptions.reduce((acca, option) => option === null ? acca : acca + 1, 0)
    if (selectedLength === product.options.length && matchingVariants.length === 1) {
      setCurrentVariant(matchingVariants[0])
    } else {
      setCurrentVariant(null)
    }
  }, [
    selectedOptions,
    product
  ])

  useEffect(() => {
    if (handle) {
      const route = getRoute();
      let currencyQuery = '';
      if (route !== '/') {
        // getting odd redirect pattern happening without confirming currency 
        // within url here
        currencyQuery = `?currency=${window.Shopify.currency.active}`;
      }
      axios.get(`${route}products/${handle}.js${currencyQuery}`).then(({ data }) => {
        if (data.variants.length === 1) {
          addToCart(
            [{
              id: data.variants[0].id,
              quantity: 1
            }],
            true,
            () => setHandle(null))
        } else {
          setProduct(data)
        }
      })
    } else {
      setProduct(null)
      setSelectedOptions([null, null, null])
    }
  }, [handle])

  return {
    product,
    stockMap,
    currentVariant,
    setHandle,
    selectedOptions,
    setSelectedOptions
  }
}

